let debounceHandlerId = null;

export const debounce = (action, timeoutInMs, externalHandlerId = null) => {
    clearDebounce(externalHandlerId);
    const newDebounceId = setTimeout(() => {
        if (action) {
            action();
        }
    }, timeoutInMs);

    if (externalHandlerId == null)
        debounceHandlerId = newDebounceId;

    return newDebounceId;
}

export const clearDebounce = (externalHandlerId) => {
    if (externalHandlerId)
        clearTimeout(externalHandlerId);
    else
        clearTimeout(debounceHandlerId);
}